<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">Select an Urgency</h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field class="select-urgency">
              <multiselect
                v-model="urgency"
                :options="urgencies"
                placeholder="Please select"
                @select="submit"
              ></multiselect>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          id="proceed-button"
          @click="submit"
        >
          Proceed
        </b-button>
        <b-button slot="right" type="is-normal" @click="cancel">
          Cancel
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
import Multiselect from "vue-multiselect";

export default {
  name: "SelectUrgencyModal",
  mixins: [UtilityMixin, scopeMixin],
  components: {
    Multiselect
  },

  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      urgency: null,
      urgencies: ["Send to Queue"],
      isModalActive: false
    };
  },

  methods: {
    cancel() {
      this.disableOKButton = true;
      this.$emit("cancel");
    },
    submit() {
      // this.form.execution_urgency = this.urgency;

      this.$emit("confirm", this.urgency);
    },
    setFocusToButton() {
      document.getElementById("proceed-button").focus();
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
